// @flow
import React from 'react';
import {useDispatch} from 'react-redux';
import {Button} from '@homeaway/react-buttons';
import {SVGIcon} from '@homeaway/react-svg';
import {MAP__16} from '@homeaway/svg-defs';

import routerActions from '../../actions/router';
import {trigger, GENERIC_EVENT} from '../../utils/edapWrapper';
import './MapButton.less';

export type Props = {
    mapButtonDisabled?: boolean
};

const MapButton = ({mapButtonDisabled = false}: Props) => {
    const dispatch = useDispatch();

    const handleMapButtonClick = () => {
        trigger(GENERIC_EVENT, {
            eventcategory: 'search',
            eventaction: 'list to map click',
            eventlabel: 'button'
        });

        dispatch(routerActions.map());
    };

    return (
        <div className={'map-button'}>
            <Button
                className={'map-button__button'}
                disabled={mapButtonDisabled}
                label={
                    <React.Fragment>
                        <SVGIcon inlineFlex markup={MAP__16} />
                        <span>{'Map'}</span>
                    </React.Fragment>
                }
                onClick={handleMapButtonClick}
                size="sm"
            />
        </div>
    );
};

export default MapButton;
